import React from 'react'
import { FormattedMessage } from 'react-intl'

type Props = {
  className?: string
}

const NotMedicalAdviceDisclaimer = ({ className }: Props) => (
  <p className={className}>
    <small className="type-nano block leading-body text-grey">
      <FormattedMessage
        id="not_medical_advice_disclaimer"
        values={{
          a: (chunks) => (
            <a
              className="text-AccentBlue"
              href="https://lifesum.helpshift.com/hc/en/3-lifesum/faq/443-support-in-case-of-problems-with-behavioural-issues/"
            >
              {chunks}
            </a>
          ),
        }}
      />
    </small>
  </p>
)

export default NotMedicalAdviceDisclaimer
